// 63版本相关多语言

export default {
    "bankTransfer": {
        "b000001": "Pending",
        "b000002": "Success",
        "b000003": "Failed",
        "b000004": "Automatically processed",
        "b000005": "Refunded",
        "b000006": "Canceled",
        "b000007": "Deposit",
        "b000008": "Withdraw",
        "b000009": "Payment",
        "b000010": "All",
        "b000011": "No More Items",
        "b000012": "Transfers Records",
        b000013: 'Exchange',
        b000014: 'Cash Transfer',
        b000015: "Bank Account(s)",
        b000016: 'Submit',
        b000017: "Binded",
        b000018: "Piece",
        b000019: "No Data Available",
        b000020: "Transfer",
        b000021: 'Account Number Instructions',
        b000022: 'Your bank account number may differ from the card number shown on your bank card. Please enter the correct bank account number. For assistance, please contact customer service.',
        b000023: 'How to find your bank account number?',
        b000024: '1. Bank statement',
        b000025: '2. Online banking app/website',
        b000026: '3. Bank account opening documents',
        b000027: '4. Bank card',
        b000028: 'Example',
    },
    moneyExchange: {
        m000001: [
            "Tips:",
            "1、In excess of HK $500,000 or its equivalent.",
            "2、The exchange rate is for reference only, the actual exchange rate will be subject to the exchange rate at the time of processing.",
            "3、By default, the outgoing currency is calculated in the incoming currency, if you want a fixed outgoing amount, please specify in the notes.",
        ],
        m000002: "Remarks",
        m000003: "From Amount",
        m000004: "Exchanged to Amount",
        m000005: "Reference Rate",
        m000006: "Updated on",
        m000007: 'Amount Available',
        m000008: "USD",
        m000009: "HKD",
        m000010: "CNH",
        m000011: "History",
        m000012: "Reference Rate",
        m000013: "No",
        m000014: "Are you sure you want to cancel?",
        m000015: "Cancellation Successful",
        m000016: "No.",
        m000017: "Cancel",
        m000018: "Exchange",
        m000019: ['Pending', 'Progressing', 'Success', 'Failed', 'Canceled', 'Service exception'],
        m000020: ['Pending','Success','Failed','Canceled'],
        m000021: "Currency exchange selection conflict"
    },
    fundsTransfer: {
        f000001: 'Transfer Out',
        f000002: 'Cannot be empty',
        f000003: 'Transfer In',
        f000004: "Currency",
        f000005: "Amount",
        f000006: 'Cash Transfer',
        f000007: 'Verify login password',
        f000008: 'Warm Tips',
        f000009: 'Got it',
        f000010: "Funds transfer order submitted successfully",
        f000011: 'Password cannot be empty',
        f000012: 'History',
        f000013: "Expected to take effect within 1 working day",
        f000014: 'Yes',
    },
    transferInto:{
        lang:'Please select remittance bank',
        lang0:'HKD、USD and CNH',
        lang1:'Fill in the transfer fund information and upload the transfer voucher',
        lang2: {
            title: "Deposit Currency",
            colums: [
                {
                    text: "HKD",
                    value: "HKD"
                },
                {
                    text: "USD",
                    value: "USD"
                },
                {
                    text: "CNH",
                    value: "CNH"
                }
            ]
        },
        lang3:'Deposit To',
        lang4:'Deposit Amount',
        lang5:'Please enter the deposit amount',
        lang6:'Funds transfer order submission successful',
        lang7:'1-3 working days estimated time for payment',
        lang8:'Got it',
        lang9:'Please select the deposit currency',
        lang10:'Please select a deposit account',
        accountName:["Futures Account","Securities Account"],
    },
    transferIntoAbroad:{
        lang:'Fill out the remittance form according to the following information',
        lang0:'Free of charge',
        lang1:'Estimated arrival time within 1~3 working days',
        lang2:'Account name',
        lang3:'Receiving account',
        lang4:'(HKD)',
        lang5:'(USD)',
        lang6:'(CNH)',
        lang7:'Bank name',
        lang8:'Bank address',
        lang9:'Copy',
        lang10:'Remitted , to upload the voucher',
        tips: [
            "Remarks / Important Notes:",
            "To safeguard client interests and facilitate prompt verification, please upload the proof of remittance as soon as possible after the funds deposit.",
            "In the event that the originating bank imposes any transfer / handling / correspondent fees, the Company reserves the right to deduct such charges from the credited funds in your account. (All incoming remittances are credited net of any applicable third-party or intermediary bank fees.)",
            "Deposit / crediting of funds is processed in accordance with the receiving bank's business / operating hours. Remittances received or instructed outside normal banking business hours (including weekends, public holidays, or after cut-off times) may be subject to processing delays. In such cases, any resulting value date adjustment or accrued interest charges (if applicable under the terms of the transaction) may be applied.",
        ],
        lang11:'Replication Success',
        lang12:'FPS ID'
    },
    withdrawNew:{
        lang:'Account list',
        lang0:'Currency',
        lang1:'Please select the transfer currency',
        lang2:'Bank Account',
        lang3:'Please select the bank card to be transferred',
        lang4:'Amount',
        lang5:'Please enter the transfer amount',
        lang6:'Total balance',
        tips:[
            'Tips',
            '1.The exchange rate may change within a certain period of time the actual amount received may differ from the expected amount received.',
            '2.Please ensure that your selected bank card can receive your transfer currency in case the funds cannot be received on time.'
        ],
        lang7:'Verify login password',
        lang8:'Withdraw order submitted successfully',
        lang9:'Funds arrive to your card in 1~3 workdays',
        lang10:'You do not have a bank card',
        lang11:'Funds need to specify the card from which they will be transferred',
        lang12:'Not for now',
        lang13:'De-binding',
        lang14:'Note that the bank card must be able to accept the above currency'
    },
    agencyList:{
        lang:'Message notification',
        lang0:'Verify that the email has been sent to your email address',
        lang1:'Open Email Activation',
        lang2:"If you can't find your email, maybe your spam folder. If the link is not working",
        lang3:'resend please',
        lang4:[{name:'Message',value:1}, {name:'To-dos',value:2}],
        lang5:'Sent successfully',
        lang6:' items',
        lang7:'Event Push',
        lang8:'View details',
    },
    bankCardPage: {
        t00001: 'Please select your bank account'
    },
    findPwd: {
        t00001: 'If you encounter any problems, please',
        t00002: 'Please enter the account opening certificate number',
        t00003: 'Please set a login password',
        t00004: 'Your account is',
        t00005: 'Password must be at least 8 characters',
        t00006: 'The password is a combination of numbers and letters',
        t00007: 'The new passwords you enter twice must be the same'
    },
    accountAnalysis: {
        a00001: 'Account Analysis',
        a00002: 'No Data Available',
        a00003: 'Statistical Time',
        a00004: 'Asset Chart',
        a00005: 'Net Asset Chart',
        a00006: 'Assets',
        a00007: 'Cumulative Net Asset Value',
        a00008: 'Data loading',
    },
    helpCenterNew: {
        m00000: 'Help Center',
        m00001: 'Please enter the problem you encountered.',
        m00002: 'Searching...',
        m00003: 'No Data Available',
        m00004: 'Guess what you want to ask',
        m00005: 'Problem classification',
        m00006: 'Other',
        m00007: '',
        m00008: '',
        m00009: '',
    },
    privateFund: {
        title: 'Private Fund',
        bannerTitleLine1: 'Selected Global Asset',
        bannerTitleLine2: 'Management Across Cycles',
        bannerSubtitle: 'Professional · Steady · Long-term Value',
        view: 'View',
        netValue: 'Total Fund Assets (B)',
        returnYtd: 'Returns (annual)',
        returnSinceInception: 'Returns (monthly)',
        list: {
            view: 'View',
            assetsUnderManagement: 'Total Fund Assets ({unit})',
            assetsUnderManagementPlain: 'Total Fund Assets',
            assetsUnderManagementBillion: 'Total Fund Assets (B)',
            assetsUnderManagementMillion: 'Total Fund Assets (M)',
            returnYtd: 'Returns (annual)',
            returnSinceInception: 'Returns (monthly)',
        },
        disclaimer: {
            title: 'Disclaimer and Terms of Use',
            paragraph1: 'The information and documents herein regarding the investment product(s) are provided and distributed by Going Securities Limited (“Going Securities”).',
            paragraph2: 'The information and documents herein shall not be construed as any form of recommendation, offer, invitation, solicitation, advertisement, inducement, or any representation of any kind with respect to any securities or investment products. They do not constitute an offer or solicitation to the public in any jurisdiction.',
            paragraph3: 'The information and documents herein are intended solely for professional investors (as defined under the Securities and Futures Ordinance (Cap. 571) of Hong Kong) and are strictly for use in Hong Kong only. They are not intended for distribution to, or use by, any person in any other jurisdiction where such distribution or use would be contrary to local law or regulation. Unless with the prior written consent of Going Securities, no recipient may reproduce, distribute, or forward the information and documents herein or any part thereof to any other person in any manner.',
            copyright: '© 2026 Going Securities Limited. All rights reserved.',
            confirm: 'Close',
        },
        finishedText: 'No more data',
        listPlaceholder: 'List page under development',
        detailPlaceholder: 'Detail page under development',
        tabOverview: 'Fund Overview',
        tabPerformance: 'Performance',
        performanceNavTrend: 'NAV PER SHARE',
        performanceNavUnit: '(USD thousands)',
        performanceNavPeriod: 'Since inception (monthly)',
        performanceChartNavLabel: 'NAV',
        navMiniChartTooltipValue: 'NAV PER SHARE: {value}',
        performanceChartNoData: 'No data',
        sectionOverview: 'Overview',
        sectionSubscription: 'Subscription',
        sectionRedemption: 'Redemption',
        sectionFees: 'Fees',
        sectionStrategy: 'Investment Strategy',
        strategyPrefix: 'Main Investment Strategy: ',
        productName: 'Fund name',
        fundCompany: 'Fund Company',
        currency: 'Currency',
        subscriptionDay: 'Subscription Day',
        subscriptionPrice: 'Subscription Price',
        minSubscription: 'Minimum Subscription',
        additionalSubscription: 'Additional Subscription',
        shareLockUp: 'Lock-up',
        redemptionDay: 'Redemption Day',
        minRedemption: 'Minimum Redemption',
        minHolding: 'Minimum Holding',
        subscriptionFee: 'Subscription Fee',
        redemptionFee: 'Redemption Fee',
        managementFee: 'Management Fee',
        performanceFeeRatio: 'Performance Fee Ratio',
        performanceFeeFrequency: 'Performance Fee Frequency',
        learnMore: 'Learn More',
        subscribeApply: 'Subscription',
        subscribe: {
            title: 'Subscription',
            product: 'Product',
            productNetValue: 'Net Value',
            securitiesAccount: 'Account',
            accountPlaceholder: 'Please enter securities account',
            accountInvalid: 'Please enter securities account',
            accountEmpty: 'Securities account cannot be empty',
            amount: 'Amount',
            amountPlaceholder: 'Please enter amount',
            minAmountHint: 'Minimum subscription amount',
            estimatedShares: 'Expected Share',
            agreementPrefix: 'I have received, read, and understood the risk disclosures in the ',
            agreementTerms: '《Term Sheet》',
            agreementMemo: '《Private Placement Memorandum》',
            agreementAppendix: '《Appendix》',
            agreementDisclosure: '《Pre-Transaction Disclosure Confirmation Statement》',
            agreementBetween: '、',
            agreementAnd: '、',
            agreementSuffix: ' .  I understand that this Fund is a complex product and I understand all the aforementioned risks.',
            submit: 'Submit',
            amountInvalid: 'Subscription amount must be greater than 0',
            minAmountInvalid: 'Subscription amount is below the minimum',
            stepAmountInvalid: 'Subscription amount must equal the minimum plus a multiple of the additional amount',
            fundIdEmpty: 'Product information is missing. Please go back and try again.',
            tokenEmpty: 'Please log in to continue. Token is empty.',
            submitSuccessMessage: 'Your subscription application has been submitted, and the relevant documents have been sent to your registered email address. Please check your inbox. Customer service will contact you within 1-3 business days to complete the remaining subscription process.',
            confirm: 'Confirm',
        },
        order: {
            title: 'Fund Orders',
            entry: 'Fund Orders',
            colName: 'Product',
            colAmount: 'Amount',
            colCurrency: 'Currency',
            colStatus: 'Status',
            colTime: 'Time',
            statusSubmitted: 'Submitted',
            statusAccepted: 'Accepted',
            statusRejected: 'Rejected',
            statusCancelled: 'Cancelled',
        },
    }
}
